import BuildImg from "../svg/Build.svg"
const Build = () => {
    return (
   
  <img src={BuildImg} />


    )
  }
  export default Build;